import { useEffect, useState } from 'react';
import { getTreatments } from './api';
import SectionHeader from './SectionHeader';

const PERIOD_OPTIONS = [
  { label: '2 мес', value: 2 },
  { label: '6 мес', value: 6 },
  { label: '12 мес', value: 12 },
];

function formatRange(r) {
  return r.date_from === r.date_to ? r.date_from : `${r.date_from} — ${r.date_to}`;
}

export default function TreatmentBlock({ petId, pdfPath, pdfName, docs, onDocsClick }) {
  const [months, setMonths] = useState(2);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getTreatments(petId, months)
      .then(setData)
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, [petId, months]);

  return (
    <section className="card-section" id="section-treatment">
      <SectionHeader
        title="Лечение"
        pdfPath={pdfPath}
        pdfName={pdfName}
        periodMode="months_years"
        sectionKey="treatment"
        docs={docs}
        onDocsClick={onDocsClick}
      />

      <div className="visits-period-tabs">
        {PERIOD_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            className={`visits-tab${months === opt.value ? ' visits-tab-active' : ''}`}
            onClick={() => setMonths(opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>
      {loading ? null : data.length === 0 ? (
        <p style={{ color: '#888', fontSize: 14, margin: 0 }}>Нет лечения за этот период</p>
      ) : (
        data.map((item, i) => (
          <div key={i} className="treatment-row">
            <div className="treatment-main">
              <span className="treatment-desc">💊 {item.description}</span>
              {item.medication && (
                <span className="treatment-med">
                  {item.medication}{item.dose ? `, ${item.dose}` : ''}
                </span>
              )}
            </div>
            <div className="treatment-dates">
              {item.ranges.map((r, ri) => (
                <span key={ri}>
                  {formatRange(r)}{ri < item.ranges.length - 1 ? ', ' : ''}
                </span>
              ))}
            </div>
          </div>
        ))
      )}
    </section>
  );
}
